package org.gstechnovos.jexonplastech.components

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Visibility
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.icons.fa.FaArrowUp
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.browser.document
import kotlinx.browser.window
import org.gstechnovos.jexonplastech.models.Theme
import org.gstechnovos.jexonplastech.styles.BackToTop
import org.gstechnovos.jexonplastech.util.Constants.LocalBreakpoint
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun BackToTopButton() {

    val breakpoint = LocalBreakpoint.current
    var scroll: Double? by remember { mutableStateOf(0.0) }

    LaunchedEffect(Unit) {
        window.addEventListener(type = "scroll", callback = {
            scroll = document.documentElement?.scrollTop ?: 0.0
        })
    }

    Box(
        modifier = BackToTop.toModifier().position(Position.Fixed)
            .bottom(40.px)
            .right(40.px)
            .zIndex(1)
            .size(50.px)
            .visibility(
                if (scroll!! > 300.0) Visibility.Visible else Visibility.Hidden
            )
            .borderRadius(20.percent)
            .margin(
                right = if (breakpoint <= Breakpoint.SM) 0.px else 20.px,
                bottom = if (breakpoint <= Breakpoint.SM) 0.px else 20.px
            )
            .backgroundColor(Theme.Primary.rgb)
            .cursor(Cursor.Pointer)
            .onClick {
                document.documentElement?.scroll(x = 0.0, y = 0.0)
            },
        contentAlignment = Alignment.Center
    ) {
        FaArrowUp(
            modifier = Modifier.color(
                Colors.White
            ), size = IconSize.LG
        )
    }
}